import React from 'react';

import './card.scss';

const Card = ({className = '', noFlex, children}) => {
  return <div className={`card ${noFlex ? '' : 'flex flex-col'} ${className}`}>{children}</div>
}

export default Card;